/* eslint-disable */
import {ReactPlugin} from "@microsoft/applicationinsights-react-js";

const getTimeStamp = (): string => new Date().toISOString();
const MAINTENANCE = (process.env.REACT_APP_MAINTENANCE !== "false");
const info = (appInsights: ReactPlugin, namespace: string, message: string, object?: any) => {
    if (MAINTENANCE) {
        if (object) {
            console.log(`[${getTimeStamp()}] [INFO] [${namespace}] ${message}`, object);
        } else {
            console.log(`[${getTimeStamp()}] [INFO] [${namespace}] ${message}`);
        }
    }
    appInsights.trackEvent({
        name: namespace,
        properties: {
            bodyValue: object,
            message: message,
            localTimeStamp: getTimeStamp(),
            trace_id: localStorage.getItem('trace_id')
        },
    });
};

const warn = (appInsights: ReactPlugin, namespace: string, message:string, object?:any) => {
    if (object) {
        console.warn(`[${getTimeStamp()}] [WARN] [${namespace}] ${message}`, object);
    } else {
        console.warn(`[${getTimeStamp()}] [WARN] [${namespace}] ${message}`);
    }
    appInsights.trackEvent({
        name: namespace,
        properties: {
            bodyValue: object,
            message: message,
            localTimeStamp: getTimeStamp(),
            trace_id: localStorage.getItem('trace_id')
        },
    });
};

const error = (appInsights: ReactPlugin, namespace: string, message:string, object?:any) => {
    if (object) {
        MAINTENANCE && console.error(`[${getTimeStamp()}] [ERROR] [${namespace}] ${message}`, object);
        appInsights.trackException({exception: new Error(`${JSON.stringify(object)}`)}, {
            name: namespace,
            properties: {
                exceptionDetail: object,
                message: message,
                localTimeStamp: getTimeStamp(),
                trace_id: localStorage.getItem('trace_id')
            },
        })
    } else {
        MAINTENANCE && console.error(`[${getTimeStamp()}] [ERROR] [${namespace}] ${message}`);
        appInsights.trackException({exception: new Error(`${JSON.stringify(message)}`)}, {
            name: namespace,
            properties: {
                message: message,
                localTimeStamp: getTimeStamp(),
                trace_id: localStorage.getItem('trace_id')
            },
        })
    }
};

const debug = (namespace: string, message:string, object?:any) => {
    if (MAINTENANCE) {
        if (object) {
            console.log(`[${getTimeStamp()}] [DEBUG] [${namespace}] ${message}`, object);
        } else {
            console.log(`[${getTimeStamp()}] [DEBUG] [${namespace}] ${message}`);
        }
    }
};

export default {
    info,
    warn,
    debug,
    error,
};
